module.exports = __webpack_public_path__ + "static/media/9.f72598d6.png";